import { AccessControl } from '@lib/state';
import { parseISO } from 'date-fns';

type PropertyDeviceDateFields =
  | 'lastSeen'
  | 'lastOffline'
  | 'lastOnline'
  | 'lastBatteryLow'
  | 'lastPowerLoss';

interface PropertyDeviceDates {
  lastSeen?: Date;
  lastOffline?: Date;
  lastOnline?: Date;
  lastBatteryLow?: Date;
  lastPowerLoss?: Date;
}

export type PropertyDevice = Omit<AccessControl.PropertyThingModel, PropertyDeviceDateFields> &
  PropertyDeviceDates;

export type DeviceType = AccessControl.ThingType;
export const DeviceType = AccessControl.ThingType;

export type LocationType = AccessControl.ThingLocationType;
export const LocationType = AccessControl.ThingLocationType;

export type PowerStatus = AccessControl.PowerStatus;
export const PowerStatus = AccessControl.PowerStatus;

export type IdentifyThingRequest = AccessControl.IdentifyThingRequest;

export type GetThingsRequest = {
  thingIdentifier?: string;
  thingLocationType?: LocationType;
  thingType?: DeviceType;
  thingStatus?: PowerStatus;
};

function parseOptionalDate(value?: string): Date | undefined {
  if (!value) return undefined;

  const parsed = parseISO(value);
  return Number.isNaN(parsed.getTime()) ? undefined : parsed;
}

export function getPropertyDevice(device: AccessControl.PropertyThingModel): PropertyDevice {
  return {
    ...device,
    lastSeen: parseOptionalDate(device.lastSeen),
    lastOffline: parseOptionalDate(device.lastOffline),
    lastOnline: parseOptionalDate(device.lastOnline),
    lastBatteryLow: parseOptionalDate(device.lastBatteryLow),
    lastPowerLoss: parseOptionalDate(device.lastPowerLoss),
  };
}
